import React from "react";
import "./grayCircle.scss";

const GrayCircle = (props) => {
  return (
    <>
      <div className="grayDiv">
        <p className="circleContent">{props.renovationName}</p>
        <div className="gradient-horiz-line mx-auto"></div>
      </div>
    </>
  );
};

export default GrayCircle;
